/* * @Author: 孙福聪 * @Date: 2019-01-16 16:02:50 * @Last Modified by: 孙福聪 * @Last Modified time:
2019-01-22 16:39:58 */
<template lang="pug">
div#app
  router-view
</template>

<script>
/* eslint-disable */
import { RequestCounter } from "./api/requestCounter";
import config from "../package.json";

export default {
  name: "app",
  computed: {
    inRequest() {
      return RequestCounter.getInstance().inRequest;
    }
  },
  watch: {
    inRequest: function(val) {
      if (val) {
        this.$Spin.show({
          render: h => {
            return h("div", [
              h("Icon", {
                class: "demo-spin-icon-load",
                props: {
                  type: "ios-loading",
                  size: 18
                }
              }),
              h("div", "加载中")
            ]);
          }
        });
      } else {
        this.$Spin.hide();
      }
    }
  },
  methods: {
    getSoft() {
      this.$http.softConfig().then(res => {
        document.title = res.data.softName;
      });
    }
  },
  created() {
    console.log("前端版本：", config.version);
    this.getSoft();
  }
};
</script>

<style lang="stylus">
@import 'assets/quill-editor/font.css'
.demo-spin-icon-load
  animation: ani-demo-spin 1s linear infinite;
.ivu-modal
  top -60px!important
.ql-toolbar.ql-snow
  background-color rgb(244, 244, 244)
.ql-snow .ql-picker
  text-align center
/* 自定义字体 */
@font-face
  font-family 'fzhpfw'
  src url('./assets/font/FZHPJW.TTF') format('truetype')
  font-weight normal
  font-style normal
.zindex6
  z-index 6
  position relative
body
  margin 0
  padding 0
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #2c3e50
// 清楚浮动
.clear
  clear:both
p
  margin-bottom 0!important
li
  list-style none
.text-button
  border none
  outline none
  background none
  cursor pointer
  font-size 14px
  font-family MicrosoftYaHeiUI
  color rgba(128, 128, 128, 0.5)
  line-height 18px
.iconfont
  cursor pointer
::-webkit-scrollbar
  width 6px
  background-color transparent
::-webkit-scrollbar-track
  background-color transparent
::-webkit-scrollbar-thumb
  background-color grey
  border-radius 100px
.Absolutely-Centralization
  position absolute
  top 0
  right 0
  left 0
  bottom 0
  margin auto
button
  cursor pointer
.ivu-modal
  margin-top 168px!important
</style>
<style>
.ql-tooltip {
  z-index: 999;
}
.ivu-input-number-input {
  z-index: auto !important;
  position: static !important;
}
</style>
